import React, { Component } from "react"
import "./cspan.css"
import YouTube from 'react-youtube';

export class CspanView extends Component {

  constructor(props) {
    super(props)
    this.state = {
      searchString: "",
      users: []
    }
  }

  handleChange = (e)=> {
        this.setState({searchString: e.target.value });
  }

  _onPlay = (event) => {
    event.target.setSize(700 ,400);
    // console.log(event.target)
    const id = event.target.f.id
    console.log(id)
    if(id === "0"){
      document.getElementsByClassName("zoom").item(0).style.gridColumn = '1/span 5'
      document.getElementsByClassName("zoom").item(0).style.zIndex = '999'
    } else if(id==="1") {
      document.getElementsByClassName("zoom").item(1).style.gridColumn = '4/ span 6'
      document.getElementsByClassName("zoom").item(1).style.zIndex = '999'
    } else {
      document.getElementsByClassName("zoom").item(2).style.gridColumn = '4/span 6'
      document.getElementsByClassName("zoom").item(2).style.zIndex = '999'
    }

  }
  _onPauseOrEnd = (event) => {
    event.target.setSize(500 ,400)
    const id = event.target.f.id
    if(id === "0"){
      document.getElementsByClassName("zoom").item(0).style.gridColumn = '1/span 4'
      document.getElementsByClassName("zoom").item(0).style.zIndex = '2'
    } else if(id === "1") {
      document.getElementsByClassName("zoom").item(1).style.gridColumn = '5/span 5'
      document.getElementsByClassName("zoom").item(1).style.zIndex = '2'
    } else {
      document.getElementsByClassName("zoom").item(2).style.gridColumn = '5/span 5'
      document.getElementsByClassName("zoom").item(2).style.zIndex = '2'
    }

  }

  render() {
    const  searchString  = this.state.searchString;
    const filteredCountries = this.props.videos.edges.filter(edge => {
      return edge.node.title.toLowerCase().indexOf(searchString.toLowerCase()) !== -1;
    });

    const opts = {
      height: '400',
      width: '500',
    };
    return (
      <div className="container-fluid">
        <div className="row mt-sm-5 no-gutters">
          <div className="col-6 mt-5">
            <h1 className="broadcast-heading">Broadcast</h1>
            <div
              className="col-sm-4  d-flex justify-content-start"
              style={{ paddingLeft: "0px" }}
            >
              <div className="red-base"/>
            </div>
            <div className="col-sm-1"/>
            <div className="col-sm-1"/>
          </div>
          {/* <div className="col-6 mt-5 form-group has-search d-flex align-items-end search-web">
   <span className="fa fa-search form-control-feedback"
   onClick={this.handleClick}
   ></span>
   <input type="text" className="form-control" placeholder="Search"
   onChange={this.filterList}
   />
 </div> */}
          <div
            className="col-6 mt-5 d-flex align-items-end search-mobile"
          
          >
            <form>
              <input
                type="text"
                name="search"
                id="search-bar"
                ref="search"
                
                onChange={this.handleChange}
              />
            </form>
          </div>

          {/* <cspanView/> */}
          <div className="col-12 mt-1" style={{ height: "850px" }}>
            <div className="mt-3  mt-sm-5 no-gutters">
              <h2 className="broadcast-heading">CSPAN</h2>

              <div
                className="cspan-pc-view mt-5 mb-5"
                style={{ height: "600px", width: "100%" }}
              >
                <ul
                  className="gallery"
                  style={{ height: "100%", width: "100%" }}
                >
                {
                  filteredCountries.map((edge, index) => {
                  return (
                      <li key={index} className="zoom">
                        <YouTube
                          id={index.toString()}
                          style={{
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            marginTop: " 0px",
                            padding: "0px",
                            width: "100%",
                            height: "100%",
                          }}
                          opts={opts}
                          videoId={edge.node.link}
                          onPlay={this._onPlay}
                          onPause={this._onPauseOrEnd}
                          onEnd={this._onPauseOrEnd}
                          // allowFullScreen="allowfullscreen"
                          // frameBorder="0"
                          // onPlay={this.handleVideoFloat}
                          // onChange={this.handleVideoFloat}
                          // onClickCapture={this.handleVideoFloat}
                          />
                      </li>

                  )
                })}

                </ul>
              </div>
            </div>
            

            <div className="cspan-mobile-view">
              <div className="col-12">
              {filteredCountries.map((view,index) => {
                return (
            <div key={index} className="row no-gutters mt-5 mt-sm-5">
                   
              <div className="col-12 col-sm-12">
                <YouTube
                  style={{
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    marginTop: " 0px",
                    padding: "0px",
                    width: "100%",
                  }}
                  className="cspan rounded mx-auto d-block"
                  width="560"
                  height="315"
                  videoId={view.node.link}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  />
                
                </div>
                
                    <div className="col-12 col-sm-12" style={{ textAlign: "center" }}>
                    <small className="card-info" style={{ fontWeight: "bolder" }}>
                    {view.node.title}
                    </small>
                    </div>
                   
               
                </div>
                )} )} 
              
              </div>
            </div>
          </div>
        
        </div>
        <script src="https://www.youtube.com/iframe_api"/>
      </div>
    )
  }
}


//
// export default () => (
//   <StaticQuery
//     query={graphql`
//       query {
//         allContentfulBroadcasts {
//           edges {
//             node {
//               cspan1
//               cspan2
//               cspan3
//               slug
//               childContentfulBroadcastsIntroductionRichTextNode {
//                 json
//               }
//             }
//           }
//         }
//         allContentfulCspanVideos {
//           edges{
//             node{
//               link
//               title
//             }
//           }
//         }
//       }
//     `}
//     render={data => <CspanView broad={data.allContentfulBroadcasts} videos={data.allContentfulCspanVideos} />
//   }
//
//   />
// )
